<script lang="ts" setup>
import 'vue-sonner/style.css';
import { RouterView } from 'vue-router';
import { ensureUserHydrated } from '@/stores';
import { Toaster } from './components/ui/sonner';

ensureUserHydrated();
</script>

<template>
  <RouterView />
  <Toaster />
</template>
